import { usePrecisionGameStore } from "../store/precisionGame.store";
import { usePrecisionGameLeaderboardStore } from "../store/precisionGameLeaderboard.store";
import usePrecisionGameSubmit from "./usePrecisionGameSubmit";
import { PrecisionGameLeaderboard } from "../models/precisionGame.types";
import { toast } from "react-toastify";
import PrecisionGameToastClose from "../components/precision.game.toast.close";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import PrecisionGameToastSuccess from "../components/precision.game.toast.success";

export const usePrecisionGameClick = (
  collection: string,
  attemptCount: number,
  values: PrecisionGameLeaderboard,
  firstClickTime: number | null,
  setFirstClickTime: (time: number | null) => void,
  setCurrentTime: (time: number) => void,
  setSuccess: (success: boolean) => void,
  winners: any[],
  mentions: any[],
  refetch: () => void
) => {
  const user = useCurrentUserProfile((s) => s.user);
  const { incrementAttemptCount, addWonCollection } = usePrecisionGameStore();
  const { setMentions, setWinners } = usePrecisionGameLeaderboardStore();
  const { submitScore } = usePrecisionGameSubmit(values, collection);

  const handleClick = async (key) => {
    if (key === "1" && firstClickTime) {
      return;
    }

    if (key === "2" && !firstClickTime) {
      return;
    }

    if (firstClickTime === null) {
      setFirstClickTime(Date.now());
    } else {
      const secondClickTime = Date.now();
      const timeDifference = secondClickTime - firstClickTime;
      setCurrentTime(timeDifference);
      incrementAttemptCount(collection);

      if (
        timeDifference >= 1331 &&
        timeDifference <= 1341 &&
        timeDifference !== 1337
      ) {
        // SUBMIT TO LEADERBOARD (Honorable Mention)
        submitScore({
          ...values,
          attempts: attemptCount + 1,
          score: timeDifference,
        });
        // Add the mention to the store
        setMentions([
          ...mentions,
          {
            ...values,
            attempts: attemptCount + 1,
            score: timeDifference,
          },
        ]);

        if (user && !user.email) {
          toast(PrecisionGameToastClose, {
            autoClose: false,
            hideProgressBar: true,
            closeOnClick: false,
            draggable: true,
          });
        } else {
          toast(
            `🎉 Tæt på! Du er nu med i lodtrækningen om et par Sony Inzone Buds gaming in-ear høretelefoner til en værdi af 1.799 kr.`,
            {
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: false,
              draggable: true,
            }
          );
        }
      }

      if (timeDifference === 1337) {
        setSuccess(true);
        addWonCollection(collection);

        // SUBMIT TO LEADERBOARD (1337)
        submitScore({
          ...values,
          attempts: attemptCount + 1,
          score: 1337,
        });

        // Add the win to the store
        setWinners([
          ...winners,
          {
            ...values,
            attempts: attemptCount + 1,
            score: 1337,
          },
        ]);

        if (user && !user.email) {
          toast(PrecisionGameToastSuccess, {
            autoClose: false,
            hideProgressBar: true,
            closeOnClick: false,
            draggable: true,
          });
        } else {
          toast(
            `🎉 Sådan! Du er nu med i lodtrækningen om en PlayStation 4 - 20th Anniversary Edition til en værdi af 10.000 kr.`,
            {
              autoClose: false,
              hideProgressBar: true,
              closeOnClick: false,
              draggable: true,
            }
          );
        }

        // Refresh leaderboard data after submitting a winning score
        refetch();
      }

      setFirstClickTime(null);
    }
  };

  return { handleClick };
};
